import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { IconComponent } from '@libs/components/icons';

@Component({
  selector: 'ui-product-bundle-max-order-count-label',
  imports: [IconComponent],
  templateUrl: './product-bundle-max-order-count-label.component.html',
  styleUrl: './product-bundle-max-order-count-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductBundleMaxOrderCountLabelComponent {
  public maxOrderCount: InputSignal<number> = input.required();
  public showIcon: InputSignal<boolean> = input(true);
  public showDot: InputSignal<boolean> = input(false);
}
